import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { EchoService } from './echo.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PresenceService {
  private ids = new BehaviorSubject<Set<number>>(new Set());
  onlineIds$ = this.ids.asObservable();
  private timer: any = null;

  constructor(private echoService: EchoService, private http: HttpClient) {}

  start() {
    if (this.timer) return;
    this.echoService.connect().join('online')
      .here((users: any[]) => this.ids.next(new Set(users.map(u => Number(u.id)))))
      .joining((u: any) => { const s = new Set(this.ids.value); s.add(Number(u.id)); this.ids.next(s); })
      .leaving((u: any) => { const s = new Set(this.ids.value); s.delete(Number(u.id)); this.ids.next(s); });

    this.ping();
    this.timer = setInterval(() => this.ping(), 60000);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
    this.ids.next(new Set());
  }

  isOnline(id: number): boolean { return this.ids.value.has(Number(id)); }

  private ping() {
    this.http.post(`${environment.apiUrl}presence/ping`, {}, { headers: this.echoService.headers() })
      .subscribe({ error: () => {} });
  }

  statusText(user: any): string {
    if (!user) return '';
    if (this.isOnline(user.id)) return 'Online';
    if (!user.last_seen_at) return 'Offline';
    const t = new Date(user.last_seen_at).getTime();
    if (isNaN(t)) return 'Offline';
    const mins = Math.floor((Date.now() - t) / 60000);
    if (mins < 1) return 'Last seen just now';
    if (mins < 60) return `Last seen ${mins} min ago`;
    if (mins < 1440) return `Last seen ${Math.floor(mins / 60)} h ago`;
    return `Last seen ${Math.floor(mins / 1440)} d ago`;
  }
}